import { TurmaApiResponse } from '../../../services/service.types';
import { TurmaAtual } from '../../turmas-atuais.types';

export const paraTurmaAtual = ({ apiResponse }: { apiResponse: TurmaApiResponse[] }): TurmaAtual[] =>
  apiResponse.map((item: TurmaApiResponse) => ({
    ...item,
  }));
